export default "__VITE_ASSET__eZewO5da__"